import { MenuRepository } from '../../domain/interfaces/MenuRepository';
import type { MenuItem } from '../../domain/models/MenuItem';

/**
 * Menu Service
 * Application layer - Orchestrates menu business logic
 */

// Type for the service returned by createMenuService
export type MenuService = ReturnType<typeof createMenuService>;

export function createMenuService(repo: MenuRepository) {
  return {
    /**
     * Get menu items
     * @returns Promise resolving to array of menu items
     */
    async getMenu(): Promise<MenuItem[]> {
      return await repo.fetchMenu();
    }
  };
}

